import { createStyles, WithStyles, withStyles } from "@material-ui/core/styles";
import { convertRelodePlansListResponse } from "apps/admin/src/shared/backend/converters";
import classnames from "classnames";
import * as React from "react";

import { RelodeTheme } from "../";
import { MergeTypes } from "../utils";
import { Link, LinkProps } from "./link";

interface AddressLinkProps extends WithStyles<typeof styles> {
    address1?: string;
    address2?: string;
    cityStatePostalCode?: string;
}

type AddressLinkPropsType = MergeTypes<AddressLinkProps, LinkProps>;

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {},
    });

export const AddressLink = withStyles(styles, { name: "AddressLink" })(
    (props: AddressLinkPropsType) => {
        const getFormattedAddress = (): string => {
            const {
                address1 = "",
                address2 = "",
                cityStatePostalCode = "",
            } = props;
            const fullAddress = `${address1} ${address2} ${cityStatePostalCode}`;
            return encodeURI(fullAddress.trim());
        };

        const {
            classes,
            className: classNameProp,
            href = `https://www.google.com/maps/search/?api=1&query=${getFormattedAddress()}`,
            target = "_blank",
            address1,
            address2,
            cityStatePostalCode,
            ...rest
        } = props;

        const rootClasses = classnames(classes.root, classNameProp);

        if (cityStatePostalCode === "Remote") return null;

        return (
            <div className={rootClasses}>
                <Link
                    id={"addressLink"}
                    href={href}
                    highlightType="external"
                    target={target}
                    {...rest}
                >
                    view on map
                </Link>
            </div>
        );
    }
);
